<script>
import { codes } from "./phone-codes";

export default {
  props: ['placeholder', 'name', 'id', 'value', 'error'],
  data() {
    return  {
      codes: codes,
      code: '+61',
      number: ''
    }
  },
  mounted() {
    if (this.$props.value) {
      const array = this.$props.value.split(')')
  
      this.code = array[0].split('(')[1]
      this.number = array[1]
    }
  },
  methods: {
    handleNumberInput(value) {

      this.number = value;

      this.$emit('input', `(${this.code})${this.number}`)
    },
    handleCodeInput(value) {
      this.code = value

      this.$emit('input', `(${this.code})${this.number}`)
    }
  },
  watch: {
    value(val) {
      if (val) {
        const array = val.split(')')
  
        this.code = array[0].split('(')[1]
        this.number = array[1]
      }
    }
  }
}
</script>

<template>
  <div class="input-group">
    <select class="custom-select" style="max-width: 90px;" @change="handleCodeInput($event.target.value)" :value="code">
      <option :value="code.value" v-for="(code, index) in codes" :key="index">{{ code.label }}</option>
    </select>
    <input type="tel" class="form-control" :class="{ 'is-invalid': error }" :placeholder="placeholder" :name="name" :id="id" v-mask="'###########'" @input="handleNumberInput($event.target.value)" :value="number" />
  </div>
</template>